/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Card_Plan_TitleInputs */

const en_landing_card_plan_title = /** @type {(inputs: Landing_Card_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const id_landing_card_plan_title = /** @type {(inputs: Landing_Card_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencanakan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Landing_Card_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_card_plan_title = /** @type {((inputs?: Landing_Card_Plan_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Card_Plan_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_card_plan_title(inputs)
	return en_landing_card_plan_title(inputs)
});